import { render } from "./Game.vue?vue&type=template&id=11d87f16&scoped=true&bindings={\"playerID\":\"props\",\"matchID\":\"props\",\"auth\":\"props\",\"state\":\"data\",\"cardSelected\":\"data\",\"errMsg\":\"data\",\"player\":\"options\",\"active\":\"options\",\"phase\":\"options\",\"oponent\":\"options\",\"myTurn\":\"options\",\"openCards\":\"options\",\"cardOnTop\":\"options\",\"leftInDeck\":\"options\",\"cardClick\":\"options\",\"OKPressed\":\"options\",\"putCard\":\"options\"}"
import script from "./Game.vue?vue&type=script&lang=js"
export * from "./Game.vue?vue&type=script&lang=js"

import "./Game.vue?vue&type=style&index=0&id=11d87f16&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-11d87f16"

export default script